import React from 'react';
import './scss/full-screen-loader.scss';
import { Button, Modal } from 'react-bootstrap';
import MessageDialogProp from './properties/message-dialog';

function MessageDialog({
  title, message, show, onHide,
}:MessageDialogProp): React.ReactElement {
  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={onHide}
    >
      <Modal.Header closeButton onHide={onHide}>
        <Modal.Title id="contained-modal-title-vcenter">
          <h5>Information!</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h6>{title}</h6>
        <p>
          {message}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default MessageDialog;
